import bpTheme from '../../themes/bpTheme';
import psccTheme from '../../themes/psccTheme';
import defaultTheme from '../../themes/defaultTheme';
export const defaultTenant = {
    value: '00000000-0000-0000-0000-000000000000',
    label: 'Default',
    name: 'default',
    theme: defaultTheme,
    platform: 'RC',
};
export const tenants = [
    {
        value: '43d2c366-699a-4311-95e8-f2f99bda7b77',
        label: 'BP',
        name: 'bp',
        theme: bpTheme,
        platform: 'RC',
    },
    {
        value: '0000-0000-0000-0000-0000-000000000000',
        label: 'Default',
        name: 'default',
        theme: defaultTheme,
        platform: 'RC',
    },
    {
        value: 'adfc20cc-10de-4e04-aa31-d878fc1e4fa5',
        label: 'PSCC',
        name: 'pscc',
        theme: psccTheme,
        platform: 'PSCC',
    },
];
export function getTenantByAccessKey(accessKey) {
    return tenants.find((val) => accessKey && val.value === accessKey.trim());
}
export function getTenantByName(name) {
    return tenants.find((val) => val.name === name.toLowerCase());
}
export function isPSCCTenant(tenant) {
    return tenant.name === 'pscc';
}
export function isBNPLTenant(tenant) {
    return tenant.name === 'bnpl';
}
let tenantThemes = Promise.resolve(undefined);
if (!process.env.REACT_APP_VISTA_PLATFORM) {
    tenantThemes = import('./TenantThemes').then((themeModule) => themeModule.default);
}
export const getTheme = (name) => {
    return tenantThemes.then(t => (t && t[name]) || defaultTheme);
};
